import React from "react";
import CountUp from "react-countup";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const testimonials = [
  {
    image: require("./../../images/testimonials/pic1.jpg"),
    reviewername: "Rosalina D. William",
    position: "Architect",
    review:
      "“Amazing fast and reliable customer support! The team of developers are willing to go mile for customer service! Thanks! which was created for the bliss of souls like mine. I am so happy, my dear friend, so absorbed in the exquisite sense of me.”",
  },
  {
    image: require("./../../images/testimonials/pic2.jpg"),
    reviewername: "Mitchal Jhon",
    position: "Architect",
    review:
      "“Amazing fast and reliable customer support! The team of developers are willing to go mile for customer service! Thanks! which was created for the bliss of souls like mine. I am so happy, my dear friend, so absorbed in the exquisite sense of me.”",
  },
  {
    image: require("./../../images/testimonials/pic3.jpg"),
    reviewername: "Barney Smith",
    position: "Interior designer",
    review:
      "“Great theme, just what we were looking for. Easy to install, easy to navigate. Well documented. Really enjoyed the support. which was created for the bliss of souls like mine. I am so happy, my dear friend, so absorbed in the exquisite sense of me.”",
  },
  {
    image: require("./../../images/testimonials/pic4.jpg"),
    reviewername: "Rosalina D. William",
    position: "Architect",
    review:
      "“Great theme, just what we were looking for. Easy to install, easy to navigate. Well documented. Really enjoyed the support. which was created for the bliss of souls like mine. I am so happy, my dear friend, so absorbed in the exquisite sense of me.”",
  },
  {
    image: require("./../../images/testimonials/pic3.jpg"),
    reviewername: "Rosalina D. William",
    position: "CEO, Intearch",
    review:
      "“Great theme, just what we were looking for. Easy to install, easy to navigate. Well documented. Really enjoyed the support. which was created for the bliss of souls like mine. I am so happy, my dear friend, so absorbed in the exquisite sense of me.”",
  },
];

var bgimg1 = require("../../images/background/image3.jfif");
var bgimg2 = require("./../../images/background/bg-5.png");
var bgimg3 = require("./../../images/background/cross-line2.png");
var bgimg4 = require("./../../images/background/bg-12.jpg");

class Testimonials1 extends React.Component {
  render() {
    const options = {
      loop: true,
      autoplay: true,
      margin: 30,
      autoplayTimeout: 6000,
      nav: false,
      dots: true,
      navText: [
        '<i class="fa fa-angle-left"></i>',
        '<i class="fa fa-angle-right"></i>',
      ],
      responsive: {
        0: {
          items: 1,
        },
        991: {
          items: 1,
        },
      },
    };
    return (
      <>
        <div className="section-full container-fluid p-b50">
          <div className="section-content">
            <div className="row">
              <div
                className="col-xl-6 col-lg-6 col-md-12 bg-gray bg-cover bg-no-repeat"
                style={{ backgroundImage: "url(" + bgimg1 + ")" }}
                data-aos-duration="800"  data-aos="fade-right"
              ></div>
              <div
                className="col-xl-6 col-lg-6 col-md-12 bg-white bg-repeat"
                // style={{ backgroundImage: "url(" + bgimg4 + ")" }}
              >
                <div className="sx-right-part mobile-page-padding  p-t80 p-b50">
                  {/* TITLE START */}
                  <div data-aos-duration="800"  data-aos="fade-up" className="m-b0">
                    <div style={{ width: 'max-content' }} className="sx-separator-outer separator-left">
                      <div className="sx-separatorbg-moving bg-repeat-x">
                        <h3 className="sep-line-one">
                          {/* Objectifs de l’Association la vallée : */}
                          Nos objectifs
                        </h3>
                      </div>
                    </div>
                  </div>
                  {/* TITLE END */}
                  {/* TESTIMONIAL START */}
                  <div data-aos-duration="800"  data-aos="fade-left" style={{ paddingLeft: "20px" }}>
                    <p className="text-black">
                      Veiller à répondre aux besoins de ses adhérents et à agir
                      pour une société meilleure afin de développer le « vivre
                      ensemble » et œuvrer pour l’intérêt général
                    </p>
                    <ul className="list-angle-right anchor-line text-black">
                      <li className="text-black">
                        Organiser des activités pédagogiques, culturelles,
                        sportives et de loisirs au profit des adhérents et des
                        membres de leur famille
                      </li>
                      <li>
                        Réaliser des programmes sociaux comprenant notamment des
                        projets d’habitat au profit de ses adhérents ;
                      </li>
                      <li>
                        Organiser des actions de bienfaisance et d’aide en
                        faveur des personnes démunies ;
                      </li>
                      <li>
                        Créer des relations de coopération et de partenariat
                        avec d’autres associations et organisations similaires
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Testimonials1;
